/**
 * Designed  & Developed by Faisal Nadaf
 * Contact: faisalfnadaf@gmail.com
 *
 * @format
 */

import { Navigation } from "@/components/customCopmonent/landingSection/navigation";
import { FooterSection } from "@/components/customCopmonent/landingSection/footer-section";
import CircularGallery from "@/components/customCopmonent/CircularGallery";
import DotGrid from "@/components/customCopmonent/DotGrid";
import { PageHeaderHero, PAGE_HERO_CLASS } from "@/components/customCopmonent/Text/PageHeaderHero";
import { SectionWrapper } from "../Clientele.page-primitives";
import { PageHeader } from "@/components/customCopmonent/Text/PageHeader";
import { RevealOnScroll } from "@/components/SpecialProjectsPage.primitives";

import React, { useEffect, useRef } from "react";
import { motion } from "framer-motion";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import { useTranslation } from "react-i18next";
import Seo from "@/components/Seo";
import { useIsMobile } from "@/hooks/hooks/use-mobile";
import {
	IndustrySectionProduct,
	IndustrySectionApplication,
} from "@/components/customCopmonent/IndustryCardsAP";

// Register ScrollTrigger
if (typeof window !== "undefined") {
	gsap.registerPlugin(ScrollTrigger);
}

const CementIndustry = () => {
	const { t } = useTranslation();

	const subIndustryTexts = t(
		"industryPages.cementIndustry.subIndustries.items",
		{ returnObjects: true },
	) as string[];
	const applicationItems = t(
		"industryPages.cementIndustry.applications.items",
		{ returnObjects: true },
	) as { title: string; description: string }[];
	const productItems = t("industryPages.cementIndustry.products.items", {
		returnObjects: true,
	}) as { title: string; description: string }[];
	const productHrefs = [
		"/products/air-cooled-heat-exchangers?industry=oil-gas",
		undefined,
		undefined,
		undefined,
		undefined,
	];

	const pageData = {
		title: t("industryPages.cementIndustry.title"),
		bgimage: "/images/headerPhotos/DSC09146.JPG",

		description: t("industryPages.cementIndustry.tagline"),

		meta: t("industryPages.cementIndustry.meta", {
			returnObjects: true,
		}) as string[],

		subIndustries: {
			title: t("industryPages.cementIndustry.subIndustries.title"),

			industries: subIndustryTexts.map((text) => ({
				image: "/noimg.png",
				text,
			})),
		},

		applications: {
			title: t("industryPages.cementIndustry.applications.title"),

			applications: applicationItems.map((item) => ({
				image: "/noimg.png",
				title: item.title,
				description: item.description,
			})),
		},

		products: {
			title: t("industryPages.cementIndustry.products.title"),
			description: t("industryPages.cementIndustry.products.description"),

			products: productItems.map((item, i) => ({
				image: "/noimg.png",
				title: item.title,
				href: productHrefs[i],
				description: item.description,
			})),
		},
	};
	const isMobile = useIsMobile();

	return (
		<>
			<Seo
				titleKey="industryPages.cementIndustry.seo.title"
				descriptionKey="industryPages.cementIndustry.seo.description"
				path="/industries/cement-industry"
			/>
			<Navigation />
			<SectionWrapper className={PAGE_HERO_CLASS}>
				<div className="absolute inset-0 ">
					<div
						className="absolute bottom-3 inset-0 opacity-35 scale-105"
						style={{
							backgroundImage: `url(${pageData.bgimage})`,
							backgroundSize: "cover",
							backgroundPosition: "center",
						}}
					/>
					<DotGrid
						dotSize={4}
						gap={15}
						baseColor="#3b0092"
						activeColor="#f09a38"
						proximity={100}
						shockRadius={200}
						shockStrength={3}
						resistance={750}
						returnDuration={1.5}
					/>
				</div>
				<PageHeaderHero
					// align="center"
					title={pageData.title}
					description={pageData.description}
					meta={pageData.meta}
				/>
			</SectionWrapper>
			<SectionWrapper
				className="pt-0  !px-0 !max-w-none"
				contentClassName="!max-w-none !px-0">
				<div className="relative flex flex-col items-center justify-center ">
					{/* ===== HEADER ===== */}
					<RevealOnScroll>
						<PageHeader
							title={pageData.subIndustries.title}
							align="center"
							className="py-6 text-center items-center "
						/>
					</RevealOnScroll>
				</div>
				<div className="relative h-[360px] sm:h-[460px] lg:h-[600px]">
					<CircularGallery
						items={pageData.subIndustries.industries}
						textColor="#000"
						borderRadius={0.05}
						bend={isMobile ? 0 : -3}
						scrollSpeed={1.5}
						scrollEase={0.05}
					/>
				</div>
			</SectionWrapper>
			<SectionWrapper
				className="pt-0  !px-0 !max-w-none"
				contentClassName="!max-w-none !px-0">
				<IndustrySectionApplication
					applications={pageData.applications.applications}
					title={pageData.applications.title}
				/>
			</SectionWrapper>
			<SectionWrapper
				className="pt-0  !px-0 !max-w-none"
				contentClassName="!max-w-none !px-0">
				<IndustrySectionProduct
					applications={pageData.products.products}
					title={pageData.products.title}
					description={pageData.products.description}
				/>
			</SectionWrapper>
			<FooterSection />
		</>
	);
};

export default CementIndustry;
